module.exports = __webpack_public_path__ + "img/smart-tv-content.056dba7c.png";